const actions = {

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    updateSidebarWidth({ commit }, width) {
      commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val);
    },
    updateUserRole({ commit }, val) {
      commit('UPDATE_USER_ROLE', val);
    },
    updateWindowWidth({ commit }, width) {
      commit('UPDATE_WINDOW_WIDTH', width);
    },
    updateSiteTitle({ commit }, title) {
      commit('UPDATE_SITE_TITLE', title);
    },
    offlineReady({ commit }, status) {
      commit('UPDATE_OFFLINE_READY', status);
    },


    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },
    updateActiveEntity({ commit }, entity){
      commit('UPDATE_ACTIVE_ENTITY', entity)
    },
    loadActiveEntity( {commit} ){
      let entity = localStorage.getItem('active_entity')
      if(entity){
        entity = JSON.parse(entity)
        commit('UPDATE_ACTIVE_ENTITY', entity)
      }
    },
    setEntityLoadRedirect({commit}, path) {
      commit('SET_ENTITY_LOAD_REDIRECT', path)
    },
    updateConnectivityStatus({commit}, status) {
      commit('SET_CONNECTIVITY_STATUS', status)
    },
    updateFCMProgress({commit}, progress) {
      commit('SET_FCM_PROGRESS', progress)
    },
    updateServiceWorker({commit}, registration){
      commit('SET_SERVICE_WORKER', registration)
    },
    updateCache({commit}, payload) {
      commit('SET_CACHE', payload)
    },
    addRenderingPersonID({ commit }, session_id) {
      commit('UPDATE_RENDER_PERSON_ID', {session_id, status: 'pending', data: null})
    },
    updateRenderPersonID({ commit }, payload) {
      commit('UPDATE_RENDER_PERSON_ID', payload)
    }
}

export default actions
